// @flow
import React from 'react'
import I18n from 'i18n-react'
import { validate } from 'devx-js-utilities'
import Modal from 'reactstrap/lib/Modal'
import ModalBody from 'reactstrap/lib/ModalBody'

// components
import { String } from '../../Components/_formFields/'
import { FieldLabel } from '../../Components/'

// core
import { createSimplyValidationError } from '../ContainerFunctions'

// types
type SendToEmailComponentProps = {
  buttonClassName?: string,
  email: string,
  label: string,
  onlyLabel?: boolean,
  onSend: (email: string) => void,
  setEmail?: (email: string) => void
}

type SendToEmailComponentState = {
  email: string,
  showModal: boolean,
  validationError: null | Object,
}

export default class SendToEmailComponent extends React.Component<SendToEmailComponentProps, SendToEmailComponentState> {
  static defaultProps = {
    buttonClassName: 'btn btn-link',
    onlyLabel: false,
  }

  state = {
    email: '',
    showModal: false,
    validationError: null,
  }

  handleOnChangeEmail = (email: string) => {
    this.setState({ email })
  }

  handleToggleModal = () => {
    this.setState({ showModal: !this.state.showModal, email: this.props.email })
  }

  handleSubmit = (event: SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault()
    if (this.state.email && validate.validateEmail(this.state.email)) {
      this.setState({ validationError: null, showModal: false })
      this.props.onSend(this.state.email)
      if (typeof this.props.setEmail === 'function') {
        this.props.setEmail(this.state.email)
      }
    } else {
      this.setState({ validationError: createSimplyValidationError('required') })
    }
  }

  render = () => {
    const { label, buttonClassName, onlyLabel } = this.props
    const { showModal, validationError, email } = this.state
    return [
      <button
        className={buttonClassName}
        key="sendToEmail-button"
        onClick={this.handleToggleModal}
      >
        {onlyLabel ? (
          <span>{label}</span>
        ) : (
          <strong>
            <span className="pfp pfp-email pr-1" />
            {label}
          </strong>
        )}
      </button>,
      <Modal
        isOpen={showModal}
        key="sendToEmail-modal"
        toggle={this.handleToggleModal}
      >
        <ModalBody>
          <form onSubmit={this.handleSubmit}>
            <div className="form-group d-flex flex-row flex-wrap flex-sm-row align-items-center">
              <div className="col-10 col-sm-3 order-0 order-sm-0 text-sm-right">
                <FieldLabel
                  id="sendToEmailComponent-email"
                  isRequired
                  label={I18n.translate("general.email")}
                />
              </div>
              <div className="col-12 col-sm-8 order-2 order-sm-0 offset-sm-1 mt-2 pr-sm-0">
                <String
                  autoFocus
                  enabled
                  id="sendToEmailComponentEmail"
                  isPristine={!!validationError}
                  name="sendToEmailComponentEmail"
                  onChange={this.handleOnChangeEmail}
                  prefix=""
                  validationErrors={{
                    sendToEmailComponentEmail: validationError
                  }}
                  value={email}
                />
              </div>
            </div>
            <div className="mt-2 text-center">
              <button className="btn btn-dark w-100" type="submit">
                {I18n.translate("general.send")}
              </button>
            </div>
          </form>
        </ModalBody>
      </Modal>
    ];
  }
}
